import { POST_PAGE_URLS, WP_BLOGS } from '@wix/communities-blog-client-common';
import { blogAppDefId } from '@app/external/common/constants/apps';
import { type PlatformApi } from '@app/external/common/controller/platform-api';

export const buildPostPageSectionUrl = async ({
  platformApi,
  instanceId,
}: {
  platformApi: PlatformApi;
  instanceId: string;
}) => {
  if (WP_BLOGS.includes(instanceId)) {
    return POST_PAGE_URLS[instanceId];
  }

  const { url } = await platformApi.site.getSectionUrl({
    sectionId: 'post',
    appDefinitionId: blogAppDefId,
  });

  return url?.split('?')?.[0] ?? '';
};
